/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type CartQuickCheckout_cart$ref: FragmentReference;
declare export opaque type CartQuickCheckout_cart$fragmentType: CartQuickCheckout_cart$ref;
export type CartQuickCheckout_cart = {|
  +lineItems: ?$ReadOnlyArray<?{|
    +__typename: string
  |}>,
  +totalPrice: ?any,
  +$refType: CartQuickCheckout_cart$ref,
|};
export type CartQuickCheckout_cart$data = CartQuickCheckout_cart;
export type CartQuickCheckout_cart$key = {
  +$data?: CartQuickCheckout_cart$data,
  +$fragmentRefs: CartQuickCheckout_cart$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "CartQuickCheckout_cart",
  "type": "Cart",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "lineItems",
      "storageKey": null,
      "args": null,
      "concreteType": "LineItem",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "__typename",
          "args": null,
          "storageKey": null
        }
      ]
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "totalPrice",
      "args": null,
      "storageKey": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '9cda712b61ca9cfe9a70b78933c0a6a4';

module.exports = node;
